<template>
  <modal v-bind:open="openModal" v-bind:title="bundle.id_12677" v-on:close="openModal = false">
    {{ bundle.id_12678 }}

    <template v-slot:footer="">
      <button class="btn btn-primary"
              type="button"
              v-on:click.prevent="openModal = false">
        {{ bundle.id_12680 }}
      </button>
      <button class="btn btn-success"
              type="button"
              v-on:click.prevent="allowPush">
        {{ bundle.id_12679 }}
      </button>
    </template>
  </modal>
</template>

<script>
import Vue from "vue";

export default {
  name: "push-notification-popup",
  data: function () {
    return {
      bundle: {
        id_12677: "Push notifications",
        id_12678: "Would you like to receive push notifications from this site? If you accept the browser will open a pop-up asking you to confirm.",
        id_12679: "Yes",
        id_12680: "No"
      },
      openModal: false,
      timeoutId: null
    }
  },
  created: function () {
    var instance = this;
    Vue.$bundle("portal", instance.bundle, function (bundle) {
      instance.bundle = bundle;
    });
  },
  mounted() {
    const seen = $.cookies.get("nm_popup_displayed_push_notification_permission");
    const eligible = window.visitor.person && Notification.permission === 'default';
    const notificationsEnabled = this.window.access.module.subscriptions;

    if (!seen && eligible && notificationsEnabled) {
      this.timeoutId = setTimeout(() => {
        this.showPopup()
      }, 5000)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    async allowPush() {
      this.openModal = false;
      await subscribe();
    },
    showPopup() {
      $.cookies.set("nm_popup_displayed_push_notification_permission",
          "true",
          {
            path: "/",
            expiresAt: new Date(Date.now() + (15 * 24 * 60 * 60 * 1000))
          }
      );

      this.openModal = true;
    }
  }
};
</script>


<style lang="less" scoped>

</style>